import Footer from './Footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/components/shared/Footer/index.js